import { AxiosResponse } from 'axios'
import { fetchWithUserAuth } from 'helpers/authHelpers/authHelpers'
import { API_URL } from 'constants/paths/paths'
import { StorefrontCompany } from '@local-types/user/storefrontUser'

export interface PagedCompanies {
	results: StorefrontCompany[]
	totalRecords: number
}

export const search = async (page = 1, pageSize = 20, query = ''): Promise<AxiosResponse<PagedCompanies>> => {
	return fetchWithUserAuth(`${API_URL}/company`, { page, pageSize, search: query })
}
